import { createSelector } from '@reduxjs/toolkit';
import { isNil, uniq } from 'lodash-es';

import type { Perspective } from '../../types/perspective';
import type { RootState } from '../types';

const NAME = 'perspectives';

export const getPerspective = (state: RootState): Perspective | undefined =>
  getPerspectiveById(state)(state.currentPerspectiveId);

export const getPerspectiveById =
  (state: RootState) =>
  (perspectiveId: string): Perspective | undefined =>
    state[NAME]?.perspectives?.find(({ id }) => id === perspectiveId);

export const getPropertyKeysFromPerspective = createSelector(
  (state: RootState) => getPerspective(state)?.labels,
  (labels) => {
    if (isNil(labels)) {
      return [];
    }

    return uniq(
      Object.values(labels)
        .flat()
        .map((a) => a.propertyKey),
    );
  },
);
